function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.521 19.723c.22-1.063 1.738-1.063 1.958 0l2.711 13.073 1.57-8.7c.187-1.034 1.638-1.117 1.942-.111l3.087 10.236.32-2.562c.127-1.012 1.51-1.207 1.912-.27l6.177 14.407c11.762 7.886 19.853 22.4 21.792 39.03a1.5 1.5 0 11-2.98.347c-1.707-14.64-8.285-27.201-17.722-34.83a1.006 1.006 0 01-.131.078l-7.283 3.642c1.972.39 3.126.863 3.126 1.371C134 56.78 125.941 61 116 61s-18-4.22-18-5.566c0-.445.883-.862 2.426-1.221l-6.568-3.284a1.006 1.006 0 01-.12-.071c-9.556 7.628-16.334 19.889-17.745 34.288a1.5 1.5 0 01-2.986-.293c1.62-16.525 10.043-30.65 21.883-38.564l7.459-16.613c.427-.951 1.843-.695 1.91.346l.391 6.056 2.403-11.53c.219-1.055 1.721-1.065 1.955-.014l1.556 7.002 3.182-11.86c.281-1.05 1.798-.961 1.955.113l.747 5.107 1.073-5.173z",
  fill: "#FFAA6C"
});

function SvgHair91(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/hair-9-1.1f7ff5ec.svg";
export { SvgHair91 as ReactComponent };